import {
  Component,
  QueryList,
  ContentChildren,
  Input,
  Output,
  EventEmitter,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { trigger, transition, animate, style } from "@angular/animations";
import { DsTabComponent } from "../ds-tab/ds-tab.component";
import { Sizes } from "../types/tab.types";

@Component({
  selector: "ds-tab-bar",
  templateUrl: "./ds-tab-bar.component.html",
  styleUrls: ["./ds-tab-bar.component.scss"],
  animations: [
    trigger("contentAnimation", [
      transition("* => *", [
        style({ opacity: 0, transform: "translateY(10px)" }),
        animate("200ms ease-out", style({ opacity: 1, transform: "translateY(0)" })),
      ]),
    ]),
  ],
})
export class DsTabBarComponent implements OnInit {
  @Input() selectedIndex: number = 0;
  @Input() size: Sizes = "md";
  @Input() customClass: string = "";
  @Input() fullWidth: boolean = false;

  @ContentChildren(DsTabComponent) tabs!: QueryList<DsTabComponent>;

  @Output() selectedTabChange = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {
    if (this.selectedIndex === 0 && this.tabs?.first) {
      this.tabs.first.active = true;
    }
  }

  ngAfterContentInit() {
    const targetTab = this.tabs.get(this.selectedIndex);
    if (targetTab) {
      targetTab.active = true;
    }

    this.updateTabSizes();

    this.tabs.forEach((tab, index) => {
      tab.select.subscribe(() => {
        this.selectedIndex = index;
        this.selectedTabChange.emit(index);
        this.tabs.forEach((t, i) => {
          t.active = i === index;
        });
      });
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["size"]) {
      this.updateTabSizes();
    }

    if (changes["selectedIndex"] && this.tabs) {
      const newIndex = changes["selectedIndex"].currentValue;
      this.updateSelectedIndex(newIndex);
    }
  }

  updateSelectedIndex(index: number) {
    this.tabs.forEach((t, i) => {
      t.active = i === index;
    });
  }

  updateTabSizes() {
    this.tabs?.forEach((tab) => {
      tab.size = this.size;
    });
  }

  get activeTab(): DsTabComponent | undefined {
    return this.tabs.get(this.selectedIndex);
  }
}
